/**
 * Nó "Gerar pagamento SPEI" (México, XPag). No motor do flow ele é um
 * card_payment com method='spei': pago/não pago e timeout funcionam como no
 * nó de cartão. O valor já é em MXN (sem conversão nem menu de moeda).
 */
export const SPEI_TYPE = "spei_payment";

const DEFAULT_TIMEOUT_MIN = 30;

export const isSpeiEngineNode = (node) =>
    node?.type === "card_payment" && node?.config?.method === "spei";

/** Dados do nó no editor → config do motor. */
export function speiEngineConfig(data = {}) {
    return {
        method: "spei",
        currency: "MXN",
        amount: parseFloat(data.paymentAmount) || 0,
        plan_info: {
            name: data.paymentPlanName || "",
            duration: data.paymentPlanDuration || "mensal",
        },
        pix_config: {
            pending_timeout_minutes: parseInt(data.pendingTimeoutMinutes, 10) || DEFAULT_TIMEOUT_MIN,
        },
    };
}

/** Config do motor → dados do nó no editor. */
export function speiNodeData(config = {}) {
    const plan = config.plan_info || {};
    return {
        paymentAmount: config.amount ?? "",
        paymentPlanName: plan.name || "",
        paymentPlanDuration: plan.duration || "mensal",
        pendingTimeoutMinutes: config.pix_config?.pending_timeout_minutes ?? DEFAULT_TIMEOUT_MIN,
    };
}
